export default "__VITE_ASSET__CuUGkUar__"